// WHY (#2175): shared contract for the post-send CONTAINER totals backfill
//   endpoint. The allow-list drives BOTH the backend gate and the web UI
//   gate from one source so they cannot drift.

import { z } from 'zod';
import { RequestStatus } from './status.js';

// Post-send statuses where a CONTAINER total may be backfilled.
// Draft-like (DRAFT/RETURN) use the draft-save path; ARCHIVE must be
// unarchived first.
export const CONTAINER_TOTALS_BACKFILL_STATUSES = [
  RequestStatus.READY_FOR_WORK,
  RequestStatus.IN_WORK,
  RequestStatus.PROCESSED,
  RequestStatus.POSTPONED,
  RequestStatus.CLOSED,
  RequestStatus.SUCCESS,
  RequestStatus.REFUSED,
  RequestStatus.CANNOT_TRANSPORT,
] as const;

// Both fields are REQUIRED and strictly > 0, finite: rejects
// missing / null / 0 / negative / NaN / Infinity.
export const SetContainerTotalsInputSchema = z
  .object({
    weight: z.number().positive().finite(),
    volume: z.number().positive().finite(),
  })
  .strict();

export type SetContainerTotalsInput = z.infer<typeof SetContainerTotalsInputSchema>;
